import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { ICase } from './types/ICase';

export interface CaseIntakeQuestions {
  is_dental_emergency?: boolean;
  in_pain?: boolean;
  pain_description?: string[];
  pain_time?: string;
  pain_level?: string;
  additional_info?: string;
  reason_for_visit?: string[];
}

export type CasePayload = {
  type?: string;
  status?: string;
  patient_id?: number;
  organization_id?: string;
  provider_id?: number;
  video_conference_date?: string | null;
  video_conference_other_participants?: string | null;
  payment_profile_id?: number | null;
  patient_current_state?: string;
  insurance_id?: number | null;
  second_insurance_id?: number | null;
  cdts?: string[] | null;
  dependent_id?: number | null;
  is_term_accepted?: boolean;
  tz?: string | null;
  license_states?: string[] | null;
  follow_up_status?: string;
  case_intake_questions?: CaseIntakeQuestions;
  intake_answers?: Record<string, any>;
  pay_with_credits?: boolean;
};

export const createNewCase = async (payload: CasePayload, userRole?: string): Promise<ICase> => {
  // GA attribution is attached as request headers by the shared client
  // interceptor; no need to duplicate the identifiers as query params.
  const prefix = getStaffScopedApiPrefix(userRole);
  const path = prefix ? `${prefix}/cases` : '/cases';

  const { data } = await client.post<ICase>(path, payload);
  return data;
};
